import React from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Review } from "./Icons/Review.svg";
import "./reviewBuilder.css";
import StarRating from "./starRating";
import { useState } from "react";
import TextInput from "../../Global Functions/textInput";
import { Link } from "react-router-dom";

const ReviewBuilder = () => {
  // eslint-disable-next-line no-unused-vars
  const [userRating, setUserRating] = useState(0);

  const handleRating = (rate) => {
    setUserRating(rate);
  };

  return (
    <MainLayout>
      <div className="overall_review_container">
        <div className="flex-container flex-justify-between align-center">
          <div className="flex-container align-center gap-10">
            <Review></Review>
            <h1>Add Review & Rating</h1>
          </div>
          <Link to="/builders">
            <button className="button-class">Go Back</button>
          </Link>
        </div>
        <div className="star_rating">
          <StarRating ratingEvent={handleRating} totalStars={5}></StarRating>
        </div>
        <div className="temp-col-2 gap-10">
          <TextInput label="User Name"></TextInput>
          <TextInput label="Profession"></TextInput>
        </div>
        <div>
          <div>
            <span>Write Review</span>
            <textarea className="width-100 border-24 " type="text" rows={10} />
          </div>
        </div>
        <div className="flex-end">
          <div className="margin-h-10">
            <Link to="/builders">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button type="submit" className="button-class">
              Save
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ReviewBuilder;
